module.exports = "#content {\n  margin: auto;\n  width: 50%;\n  padding: 10px;\n  text-align: center; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/logout-keycloak/logout-keycloak.component.scss
// module id = ./src/app/logout-keycloak/logout-keycloak.component.scss
// module chunks = main